import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import ImagePlaceholder from "components/ui/source/components/Placeholders/ImagePlaceholder";
import TextPlaceholder from "components/ui/source/components/Placeholders/TextPlaceholder";

import styles from "./Collection.module.scss";
import placeholderStyles from "./CollectionPlaceholder.module.scss";

function CollectionPlaceholder({ className }) {
  return (
    <section
      className={classnames(
        styles.container,
        placeholderStyles.container,
        className,
      )}
    >
      <ImagePlaceholder
        className={classnames(styles.photo_container, placeholderStyles.photo)}
      />

      <div
        className={classnames(
          styles.description_container,
          placeholderStyles.descriptionContainer,
        )}
      >
        <TextPlaceholder className={placeholderStyles.header} />

        <div
          className={classnames(
            styles.base_information,
            placeholderStyles.baseInformation,
          )}
        >
          <TextPlaceholder className={placeholderStyles.baseInfo} />
          <TextPlaceholder className={placeholderStyles.baseInfo} />
          <TextPlaceholder className={placeholderStyles.baseInfo} />
        </div>

        <div className={styles.features}>
          <TextPlaceholder className={placeholderStyles.featuresHeader} />
          <div className={placeholderStyles.featuresList}>
            <TextPlaceholder className={placeholderStyles.feature} />
            <TextPlaceholder className={placeholderStyles.feature} />
            <TextPlaceholder className={placeholderStyles.feature} />
            <TextPlaceholder className={placeholderStyles.feature} />
          </div>
        </div>
      </div>

      <div
        className={classnames(
          styles.quote_container,
          placeholderStyles.quoteContainer,
        )}
      >
        <TextPlaceholder className={placeholderStyles.price} />
        <TextPlaceholder className={placeholderStyles.bookButton} />
      </div>
    </section>
  );
}

export default CollectionPlaceholder;

CollectionPlaceholder.propTypes = {
  className: PropTypes.string,
};
